// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../Users/shinri/AppData/Roaming/npm/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ShogiPlayer .DebugBlockRow th{text-align:right;background-color:#f5f5f5}", ""]);
// Exports
module.exports = exports;
